export default __webpack_public_path__ + "static/media/profile-photo-straight.106b3c5a.jpeg";